import React, { Fragment } from 'react'
import { UseFormRegister } from 'react-hook-form'

interface ApInputProps {
  name: string
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors: any
  placeholder?: string
  rules?: any
  disabled?: boolean
  isDisabled?: boolean
  isManagerDraft?: boolean
}

export const ApTextareaTwo = ({
  name,
  index,
  register,
  errors,
  placeholder,
  rules,
  disabled,
  isDisabled,
}: ApInputProps) => {
  return (
    <Fragment>
      <textarea
        className={`form-control w-100 kpi-textarea ${isDisabled === false ? 'e-kpi-textarea' : ''} ${
          errors && errors.kpi && errors.kpi[index]?.employee_comment ? 'is-invalid w-10' : ''
        }`}
        placeholder={placeholder}
        {...register(name, rules)}
        disabled={disabled}
        rows={4}
      ></textarea>

      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.employee_comment?.message}</div>
      )}
      {errors && errors.kpi && (
        <div className='invalid-feedback'>{errors.kpi[index]?.manager_comment?.message}</div>
      )}
    </Fragment>
  )
}
